import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import sendRequest from "../../../helpers/requestHelper";
import {handleError} from "../../../helpers/handleError";

const loginMain = {
    namespaced: true,
    state: {
        isFetching: false,
        isUserLogin: false,
        modalData: {}
    },
    mutations: {
        LOGIN_REQUEST(state, value) {
            state.isFetching = value;
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isUserLogin = value;
        },
        LOGIN_SUCCESS(state, response) {
            localStorage.setItem("tokenAuth", response.data.data.token);
            localStorage.setItem("isSubscribing", response.data.data.isSubscribing);
            localStorage.setItem("userName", response.data.data.userName);
            localStorage.setItem("companyIsVatPayer", response.data.data.companyIsVatPayer);
            localStorage.setItem("companyLogo", response.data.data.logo);

            window.location.href = "/companies/my";

        },
        LOGIN_FAILURE(state, error) {
            state.isUserLogin = true;
            state.isFetching = false;
            state.modalData.textInfoLogin = handleError(error) !== "" ? handleError(error) : error.response.data.data.textInfo;
            state.modalData.headInfoLogin = error.response.data.message;
            state.modalData.typeInfoLogin = "red";
            eventBus.$emit("failureLogin", error.response.data.errors);
        }
    },
    actions: {
        loginUser({dispatch}, payload) {
            dispatch("requestLogin", true);
            var promise = sendRequest("post", config.baseURLApi+"/users/login", {}, payload.creds, false);

            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("successLogin", $result[1]);
                } else {
                    dispatch("failureLogin", $result[1]);
                }
            });
        },
        logoutUser() {
            localStorage.removeItem("tokenAuth");
            localStorage.removeItem("companyFirstName");
            localStorage.removeItem("companyLastName");
            localStorage.removeItem("companyLogo");
            localStorage.removeItem("companyName");
            localStorage.removeItem("isSubscribing");
            localStorage.removeItem("userName");
            localStorage.removeItem("companyIsVatPayer");
            window.location.href = "/user/login";
        },
        requestLogin: function({ commit }, value) {
            commit("LOGIN_REQUEST", value);
        },
        successLogin: function({ commit }, response) {
            commit("LOGIN_SUCCESS", response);
        },
        failureLogin: function({ commit }, error) {
            commit("LOGIN_FAILURE", error);
        },
        updateVisibleModal(context, value)
        {
            context.commit('UPDATE_VISIBLE_MODAL', value)
        }
    }
}

export default loginMain;